import { render, staticRenderFns } from "./results.vue?vue&type=template&id=7fa0a844&lang=pug&"
import script from "./results.vue?vue&type=script&lang=js&"
export * from "./results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/banking/prepayCards?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230602131631%2Fcomponents%2Fproducts%2Fprepay-cards%2Fresults.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsResultsHeader: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/results/header.vue').default,WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/image.vue').default,WidgetsResultsFigure: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/results/figure.vue').default,WidgetsListItem: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/list-item.vue').default,WidgetsResultsAccordion: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/results/accordion.vue').default,WidgetsResultsColumnar: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/results/columnar.vue').default,WidgetsResultsCta: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/results/cta.vue').default,WidgetsResultsItem: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/results/item.vue').default,WidgetsResultsList: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/results/list.vue').default,WidgetsResultsPage: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/results/page.vue').default})
